import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AchizitiiService {
    private basePath = environment.interop.authCore.basePath;
    private getYearsList = this.basePath + environment.interop.authCore.institutii.achizitii.getYears;
    private getDocumenteList = this.basePath + environment.interop.authCore.institutii.achizitii.getDocumente;
    public fileDownloadUrl = this.basePath + environment.interop.authCore.institutii.downloadFile;

    constructor(private http: HttpClient) { }

    getYears(instition: string) {
        return this.http.get(this.getYearsList + instition);
    }

    getDocumente(instition: string, year: number) {
        return this.http.get(this.getDocumenteList + instition + '/' + year);
    }
}
